import * as Yup from "yup";
import {
  RosTemplate,
  RosTemplateTemplateTypesEnum,
  RosTemplateType,
} from "../../../../../services";
import { isRichTextEmpty } from "./template-utils";

export const TEMPLATE_BODY_REQUIRED_TEST = "template-body-not-empty";
export const TEMPLATE_BODY_REQUIRED_MESSAGE = "Body is a required field";

const RICH_TEXT_TEMPLATE_TYPES: RosTemplateTemplateTypesEnum[] = [
  RosTemplateTemplateTypesEnum.Email,
  RosTemplateTemplateTypesEnum.Sms,
];

export const TEMPLATE_VALIDATION_SCHEMA = Yup.object({
  // speciality: Yup.array()
  //   .min(1, "Specialty is a required field")
  //   .required()
  //   .label("Specialty"),
  templateName: Yup.string().required().label("Template Name"),
  templateTypes: Yup.string().required().label("Template Type"),
  subject: Yup.string().when("templateTypes", {
    is: RosTemplateTemplateTypesEnum.Email,
    then: (schema) => schema.trim().required().label("Subject"),
    otherwise: (schema) => schema.notRequired(),
  }),
  description: Yup.string().when("templateTypes", {
    is: (v: RosTemplateTemplateTypesEnum) =>
      RICH_TEXT_TEMPLATE_TYPES.includes(v),
    then: (schema) =>
      schema.test(
        TEMPLATE_BODY_REQUIRED_TEST,
        TEMPLATE_BODY_REQUIRED_MESSAGE,
        (value) => !isRichTextEmpty(value)
      ),
    otherwise: (schema) => schema.notRequired(),
  }),
  // customForm: Yup.string().when("formType", {
  //   is: (v: string) => v === "EMAIL" || v === "SMS",
  //   then: (schema) => schema.notRequired(),
  //   otherwise: (schema) => schema.required().label("Form"),
  // }),
});

interface CustomFormTemplate extends Omit<
  RosTemplate,
  "templateTypes" | "speciality"
> {
  templateTypes?: RosTemplateTemplateTypesEnum;
  speciality?: any;
}

export const TEMPLATE_FORM_INITIAL_VALUES: CustomFormTemplate = {
  templateTypes: undefined,
  templateName: "",
  speciality: undefined,
};

export const newPeTemplateInitialData: RosTemplateType[] = [
  { name: "General Appearance", isSelected: true, isBaseType: true },
  { name: "HEENT", isSelected: true, isBaseType: true },
  { name: "Neck", isSelected: true, isBaseType: true },
  { name: "Chest and Lungs", isSelected: true, isBaseType: true },
  { name: "Mouth/Speech", isSelected: true, isBaseType: true },
  { name: "Abdomen", isSelected: true, isBaseType: true },
  { name: "Genitourinary", isSelected: true, isBaseType: true },
  { name: "Rectal", isSelected: true, isBaseType: true },
  { name: "Lymphatic", isSelected: true, isBaseType: true },
  { name: "Back/Spine", isSelected: true, isBaseType: true },
  { name: "Joints/Endocrine", isSelected: true, isBaseType: true },
  { name: "Skin", isSelected: true, isBaseType: true },
  { name: "Neurological System", isSelected: true, isBaseType: true },
  { name: "Gait", isSelected: true, isBaseType: true },
  { name: "Mood and affect", isSelected: true, isBaseType: true },
  { name: "Behavior", isSelected: true, isBaseType: true },
];

export const newRosTemplateInitialData: RosTemplateType[] = [
  { name: "General", value: "", isSelected: true, isBaseType: true },
  { name: "Diet", value: "", isSelected: true, isBaseType: true },
  { name: "Exercise", value: "", isSelected: true, isBaseType: true },
  { name: "Eyes", value: "", isSelected: true, isBaseType: true },
  { name: "HENT", value: "", isSelected: true, isBaseType: true },
  { name: "Resp", value: "", isSelected: true, isBaseType: true },
  { name: "CVS", value: "", isSelected: true, isBaseType: true },
  { name: "Breast", value: "", isSelected: true, isBaseType: true },
  { name: "GI", value: "", isSelected: true, isBaseType: true },
  { name: "GU", value: "", isSelected: true, isBaseType: true },
  { name: "Gyne", value: "", isSelected: true, isBaseType: true },
  { name: "MSS", value: "", isSelected: true, isBaseType: true },
  { name: "NS", value: "", isSelected: true, isBaseType: true },
  { name: "Skin", value: "", isSelected: true, isBaseType: true },
  { name: "Hemo", value: "", isSelected: true, isBaseType: true },
  { name: "Endoc", value: "", isSelected: true, isBaseType: true },
  { name: "Psych", value: "", isSelected: true, isBaseType: true },
];

export const sections = [
  {
    title: "Patient Demographics & Contact",
    groups: [
      {
        label: null,
        fields: [
          { label: "Patient Full Name", value: "{{patient_full_name}}" },
          { label: "Patient Name", value: "{{patient_name}}" },
          { label: "Patient First Name", value: "{{patient_first_name}}" },
          { label: "Patient Last Name", value: "{{patient_last_name}}" },
          { label: "Patient MRN", value: "{{patient_mrn}}" },
          { label: "Patient DOB", value: "{{patient_dob}}" },
          {
            label: "Patient Gender Identity",
            value: "{{patient_gender_identity}}",
          },
          {
            label: "Patient Primary Language",
            value: "{{patient_primary_language}}",
          },
          {
            label: "Patient Insurance Provider",
            value: "{{patient_insurance_provider}}",
          },
          {
            label: "Patient Insurance Member ID",
            value: "{{patient_insurance_member_id}}",
          },
        ],
      },
      {
        label: "Contact",
        fields: [
          {
            label: "Patient Email Address",
            value: "{{patient_email_address}}",
          },
          {
            label: "Patient Mobile Number",
            value: "{{patient_mobile_number}}",
          },
          { label: "Patient Home Phone", value: "{{patient_home_phone}}" },
          { label: "Patient SMS Opt-In", value: "{{patient_sms_opt_in}}" },
          {
            label: "Patient Primary Address",
            value: "{{patient_primary_address}}",
          },
          { label: "Patient City", value: "{{patient_city}}" },
          { label: "Patient State", value: "{{patient_state}}" },
          { label: "Patient ZIP Code", value: "{{patient_zip_code}}" },
        ],
      },
    ],
  },

  {
    title: " Provider / Clinician",
    groups: [
      {
        label: null,
        fields: [
          { label: "Provider Full Name", value: "{{provider_full_name}}" },
          { label: "Provider Specialty", value: "{{provider_specialty}}" },
          { label: "Provider NPI", value: "{{provider_npi}}" },
          {
            label: "Supervising Provider Name",
            value: "{{supervising_provider_name}}",
          },
        ],
      },
      {
        label: "Contact",
        fields: [
          { label: "Provider Email", value: "{{provider_email}}" },
          { label: "Provider Phone", value: "{{provider_phone}}" },
          {
            label: "Provider Office Address",
            value: "{{provider_office_address}}",
          },
        ],
      },
    ],
  },
  {
    title: "Practice Details",
    groups: [
      {
        label: null,
        fields: [
          { label: "Practice Name", value: "{{practice_name}}" },
          { label: "Practice NPI", value: "{{practice_npi}}" },
          { label: "Practice Tax ID", value: "{{practice_tax_id}}" },
          { label: "Practice Type", value: "{{practice_type}}" },
          {
            label: "Practice Support Email",
            value: "{{practice_support_email}}",
          },
          {
            label: "Practice Support Phone",
            value: "{{practice_support_phone}}",
          },
          {
            label: "Practice Billing Email",
            value: "{{practice_billing_email}}",
          },
          {
            label: "Practice Billing Phone",
            value: "{{practice_billing_phone}}",
          },
          {
            label: "Practice Address Line",
            value: "{{practice_address_line}}",
          },
          { label: "Practice City", value: "{{practice_city}}" },
          { label: "Practice State", value: "{{practice_state}}" },
          { label: "Practice Zip", value: "{{practice_zip}}" },
        ],
      },
    ],
  },
  // {
  //   title: "Facility / Practice / Clinic",
  //   groups: [
  //     {
  //       label: null,
  //       fields: [
  //         { label: "Facility Name", value: "{{facility_name}}" },
  //         { label: "Facility NPI", value: "{{facility_npi}}" },
  //         { label: "Facility Tax ID", value: "{{facility_tax_id}}" },
  //         { label: "Facility Type", value: "{{facility_type}}" },
  //       ],
  //     },
  //     {
  //       label: "Contact",
  //       fields: [
  //         {
  //           label: "Facility Support Email",
  //           value: "{{facility_support_email}}",
  //         },
  //         {
  //           label: "Facility Support Phone",
  //           value: "{{facility_support_phone}}",
  //         },
  //         {
  //           label: "Facility Billing Email",
  //           value: "{{facility_billing_email}}",
  //         },
  //         {
  //           label: "Facility Billing Phone",
  //           value: "{{facility_billing_phone}}",
  //         },
  //         {
  //           label: "Facility Address Line",
  //           value: "{{facility_address_line}}",
  //         },
  //         { label: "Facility City", value: "{{facility_city}}" },
  //         { label: "Facility State", value: "{{facility_state}}" },
  //         { label: "Facility Zip", value: "{{facility_zip}}" },
  //       ],
  //     },
  //   ],
  // },
];
